var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 100.06",
    style: {
      enableBackground: "new 0 0 122.88 100.06"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.38,0h110.11c3.51,0,6.39,2.87,6.39,6.38v87.29c0,3.51-2.87,6.38-6.39,6.38H6.38 c-3.51,0-6.38-2.87-6.38-6.38V6.38C0,2.87,2.87,0,6.38,0L6.38,0z M26.1,31.43h30.77v7.95H37.63v5.92h17.83v7.59H37.63v7.33h19.8 v8.42H26.1V31.43L26.1,31.43z M61.23,31.43h10.73l13.95,20.55V31.43h10.86v37.21H85.91L72.04,48.2v20.43H61.23V31.43L61.23,31.43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.fa61d200cc3f48553b56aed99732596e.svg";
export { ForwardRef as ReactComponent };